import React from "react";
import { Checkbox, Divider, Slider } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actions as resAct } from "../../../../ReservePage/_redux/reserveRedux";
import { useMediaQuery } from "react-responsive";
import queryStringParse from "../../../../../../functions/queryParam";
export default (props) => {
  const [depDateTime, setDepDateTime] = React.useState("00:00");
  const [retDateTime, setRetDateTime] = React.useState("24:00");

  let { state } = useSelector((state) => ({
    state: state.search,
  }));

  const { } = props;

  const history = useHistory();
  const dispatch = useDispatch();

  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });

  function timeRangeValueLabelFormatDep(value) {
    if (value) {
      const hour = Math.floor(value / 60);
      const minutes = value % 60;

      return `${hour.toLocaleString("fa-IR", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}:${minutes.toLocaleString("fa-IR", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}`;
    }
  }

  function timeRangeValueLabelFormatRet(value) {
    if (value) {
      const hour = Math.floor(value / 60);
      const minutes = value % 60;

      return `${hour.toLocaleString("fa-IR", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}:${minutes.toLocaleString("fa-IR", {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })}`;
    }
  }
  let params=[];

    
  if (history.location.search ) {
    var search = history.location.search;
     params = queryStringParse(search);
 
 }
 const searchedDate = params.date;
  // const searchedDate = history.location.pathname.split("/")[4];

  return (
    <div
      className={`col-lg-3 bg-white p-5 ${!isTabletOrMobile && "dg1-border"}`}
      style={{ borderRadius: 13, height: "45rem" }}
    >
      {/* <h4 className="my-5">مسیر حرکت</h4>
  <div>
    <Checkbox
      onChange={(e) => {
        // setIsDirect(e.target.checked);
        // const date1 = new Date(
        //   `${searchedDate}T${depDateTime}:00.000Z`
        // ).valueOf();
        // const date3 = new Date(
        //   `${searchedDate}T${retDateTime}:00.000Z`
        // ).valueOf();
        // const filtered = state.results.filter((el) => {
        //   return date1 < new Date(el.ridingTime).valueOf();
        // });
        // const secFiltered = filtered.filter((el) => {
        //   return (
        //     new Date(el.ridingTime).valueOf() < date3 &&
        //     el.isMidway === isMidway
        //   );
        // });
        // dispatch(resAct.setMockTravels(secFiltered));
      }}
      defaultChecked
      style={{ color: "#6dd06d" }}
    />
    <span>مستقیم</span>
  </div>
  <div>
    <Checkbox
      onChange={(e) => {
        setIsMidway(!e.target.checked);

        const date1 = new Date(
          `${searchedDate}T${depDateTime}:00.000Z`
        ).valueOf();
        const date3 = new Date(
          `${searchedDate}T${retDateTime}:00.000Z`
        ).valueOf();

        const filtered = state.results.filter((el) => {
          return date1 < new Date(el.departureDatetime).valueOf();
        });
        const secFiltered = filtered.filter((el) => {
          return new Date(el.arrivedTime).valueOf() < date3;
        });

        const lastFiltered = secFiltered.filter((el) => {
          return el.isMidway === isMidway;
        });

        dispatch(resAct.setMockTravels(lastFiltered));
      }}
      style={{ color: "#6dd06d" }}
    />
    <span>بین راهی</span>
  </div>
  <Divider className="my-5" /> */}
      <h4 className="my-5">زمان حرکت</h4>
      <Slider
        defaultValue={0}
        valueLabelDisplay="auto"
        valueLabelFormat={timeRangeValueLabelFormatDep}
        min={0}
        max={1440}
        step={15}
        style={{ color: "#6dd06d" }}
        onChange={(e, value) => {
          const hour = Math.floor(value / 60);
          const minutes = value % 60;

          setDepDateTime(
            `${hour < 10 ? "0" : ""}${hour.toLocaleString("en-US")}:${minutes < 10 ? "0" : ""
            }${minutes.toLocaleString("en-US")}`
          );

          const date1 = new Date(
            `${searchedDate}T${depDateTime}:00.000Z`
          ).valueOf();
          const date3 = new Date(
            `${searchedDate}T${retDateTime}:00.000Z`
          ).valueOf();

          const filtered = state.results.filter((el) => {
            return date1 < new Date(el.departureDatetime).valueOf();
          });
          const secFiltered = filtered.filter((el) => {
            return date3 > new Date(el.departureDatetime).valueOf();
          });

          dispatch(resAct.setMockTravels(secFiltered));
        }}
      />
      <h4 className="my-5">زمان رسیدن</h4>
      <Slider
        defaultValue={1440}
        valueLabelDisplay="auto"
        valueLabelFormat={timeRangeValueLabelFormatRet}
        min={0}
        max={1440}
        step={15}
        onChange={(e, value) => {
          const hour = Math.floor(value / 60);
          const minutes = value % 60;

          setRetDateTime(
            `${hour < 10 ? "0" : ""}${hour.toLocaleString("en-US")}:${minutes < 10 ? "0" : ""
            }${minutes.toLocaleString("en-US")}`
          );

          const date1 = new Date(
            `${searchedDate}T${depDateTime}:00.000Z`
          ).valueOf();
          const date3 = new Date(
            `${searchedDate}T${retDateTime}:00.000Z`
          ).valueOf();

          const filtered = state.results.filter((el) => {
            return date1 < new Date(el.arrivedTime).valueOf();
          });
          const secFiltered = filtered.filter((el) => {
            return new Date(el.arrivedTime).valueOf() < date3;
          });

          dispatch(resAct.setMockTravels(secFiltered));
        }}
        style={{ color: "#6dd06d" }}
      />
      <Divider className="my-5" />
      <h4 className="my-5">نوع اتوبوس</h4>
      <div>
        <Checkbox
          // onChange={(e) => {
          //   setIsDiscount(e.target.checked);
          // }}
          defaultChecked
          style={{ color: "#6dd06d" }}
        />
        <span>با تخفیف</span>
      </div>
      {/* <div className="mb-3">
    <Checkbox defaultChecked style={{ color: "#6dd06d" }} />
    <span>بین راهی</span>
  </div> */}
    </div>
  );
};
